export default "__VITE_ASSET__DxT1cGEa__"